import { Pagination } from 'types'

export const ALERT_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 12,
  sort: {
    by: 'id',
    order: 'DESC',
  },
}
